<template>
    <div class="grid grid-cols-12 base-responsive-gap">
        <div class="col-span-12 sm:col-span-5 lg:col-span-4 lg:col-start-2 flex flex-col items-start z-2">
            <h2 class="header-3 mb-4 mt-8"><T :t="titleKey" /></h2>
            <div class="whitespace-pre-line"><T :t="descriptionKey" /></div>
        </div>

        <div class="hidden sm:block col-span-12 sm:col-span-7 lg:col-span-6">
            <div class="aspect-w-3 aspect-h-2"></div>
        </div>

        <div class="col-span-12 swiper-container">
            <div ref="swiper" class="swiper mx-[-10px] px-[10px]">
                <div class="swiper-wrapper sm:mx-0 sm:px-0 sm:grid sm:grid-cols-12 sm:gap-4 lg:gap-7">
                    <div v-for="(image, i) in images" :key="`gallery-image-${i}`" class="swiper-slide">
                        <div
                            v-if="i === 0"
                            class="aspect-w-1 aspect-h-1 sm:aspect-none sm:absolute w-full sm:-top-4 lg:-top-7 sm:right-0 sm:-translate-y-full"
                        >
                            <div class="grid grid-cols-12 base-responsive-gap">
                                <div class="col-span-12 sm:col-span-7 sm:col-start-6 lg:col-span-6 lg:col-start-6">
                                    <div
                                        class="absolute w-full h-full top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 sm:w-auto sm:h-auto sm:translate-y-0 sm:translate-x-0 sm:top-0 sm:left-0 sm:aspect-w-3 sm:aspect-h-2 sm:relative base-responsive-rounding cursor-pointer"
                                        @click="() => openLightbox(i)"
                                    >
                                        <img
                                            :src="image.src"
                                            :alt="`${$t('generic.gallery_image_alt_text')} ${i}`"
                                            class="object-cover w-full h-full"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-else
                            class="swiper-slide__inner base-responsive-rounding cursor-pointer"
                            @click="() => openLightbox(i)"
                        >
                            <img
                                :src="image.src"
                                :alt="`${$t('generic.gallery_image_alt_text')} ${i}`"
                                class="object-cover w-full h-full"
                            />
                        </div>
                    </div>
                </div>

                <div
                    class="carousel-pagination-block container relative mt-6 grid grid-cols-12 base-responsive-gap sm:hidden"
                >
                    <div class="col-span-12 flex items-center justify-center">
                        <button ref="prevBtn" class="swiper-button-prev"></button>
                        <span class="gallery-pagination-counter">01</span>
                        <div ref="pagination" class="swiper-pagination"></div>
                        <span class="gallery-pagination-counter">{{ String(images.length).padStart(2, '0') }}</span>
                        <button ref="nextBtn" class="swiper-button-next"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Type7Block',
    props: {
        titleKey: {
            type: String,
            required: true,
        },
        descriptionKey: {
            type: String,
            required: true,
        },
        images: {
            type: Array,
            required: true,
        },
    },
    mounted() {
        this.gallery = new this.$swiper(this.$refs.swiper, {
            spaceBetween: 16,
            slidesPerView: 1.2,
            centeredSlides: false,
            loop: false,
            navigation: {
                nextEl: this.$refs.nextBtn,
                prevEl: this.$refs.prevBtn,
            },
            pagination: {
                el: this.$refs.pagination,
                clickable: true,
                bulletElement: 'button',
            },
            breakpoints: {
                640: {
                    a11y: {
                        enabled: false,
                    },
                },
            },
            a11y: {
                containerMessage: this.$t('carousel.a11y.container_message_gallery'),
                paginationBulletMessage: this.$t('carousel.a11y.pagination_bullet_message'),
                firstSlideMessage: this.$t('carousel.a11y.first_slide_message'),
                lastSlideMessage: this.$t('carousel.a11y.last_slide_message'),
                nextSlideMessage: this.$t('carousel.a11y.next_slide_message'),
                prevSlideMessage: this.$t('carousel.a11y.prev_slide_message'),
            },
        });
    },
    beforeDestroy() {
        this.gallery.destroy();
    },
    methods: {
        openLightbox(slideIndex) {
            this.$nuxt.$emit('open-lightbox', {
                index: slideIndex,
                items: this.images,
            });
        },
    },
};
</script>

<style scoped>
@media (max-width: 639px) {
    .swiper-slide__inner {
        @apply aspect-w-1 aspect-h-1;
    }
}

@media (min-width: 640px) {
    .swiper {
        overflow: visible;
    }
    .swiper-slide {
        width: unset !important;
        margin: unset !important;

        &:nth-child(1) {
            width: 100% !important;
            @apply absolute top-0 right-0;
        }
        &:nth-child(2) {
            @apply col-span-5 col-start-2;
            .swiper-slide__inner {
                @apply aspect-w-3 aspect-h-2;
            }
        }
        &:nth-child(3) {
            @apply col-span-4;
            .swiper-slide__inner {
                @apply aspect-w-9 aspect-h-10;
            }
        }
    }
}
</style>
